<template>
    <div class="workflow">
        <TermsDialog
        v-if="showTermsDialog"
        v-bind:tncsVersion="tncsVersion"
        v-bind:tncsDoc="tncsDoc"
        v-bind:disableAccept="disableTncsAccept"
        tncsTitle="EARTH BLOX TERMS AND CONDITIONS"
        tncsRejectButtonTxt="Preview"
        tncsRejectAlertContent="You can explore Earth Blox in preview mode but access will be restricted and you will not be able to run worfklows. Please refresh to accept Terms and Conditions"
        tncsRejectAlertConfirm="Ok, got it"
        />

        <AnalyticsDialog
        v-if="showAnalytics && !showTermsDialog"
        @cancel-analytics="cancelAnalytics"
        />

        <NetPromoterSurvey v-if="!showAnalytics" />

        <div
        class="workflow-row"
        ref="workflowRow"
        v-bind:style="{ flexDirection: flexDirection }"
        >
            <div :class="['workflow-column', 'left-column']" ref="blockCol" id="blockCol">
                <md-card>
                    <div class="blockly-buttons">
                        <md-button @click="loadFeaturedWorkflows()" class="md-dense" v-if="workflowsLibraryEnabled">Workflows Library</md-button>

                        <md-button @click="clearWorkflow()" class="md-dense clear-button">Clear</md-button>

                        <md-button
                            v-if="orgType === 'mooc'"
                            class="md-dense greyed-out"
                            title="Upgrade to Earth Blox Enterprise to access this functionality"
                        >
                            Load
                        </md-button>
                        <md-button v-else @click="loadWorkflow()" class="md-dense">Load</md-button>

                        <md-button
                            v-if="orgType === 'mooc'"
                            class="md-dense greyed-out"
                            title="Upgrade to Earth Blox Enterprise to access this functionality"
                        >
                            Save
                        </md-button>

                        <md-button v-else @click="saveWorkflow()" class="md-dense">Save</md-button>

                        <!-- <md-button @click="shareWorkflow()" class="md-dense">Share</md-button> -->
                    </div>
                    <BlocklyComponent
                        ref="blocklyComponent"
                        class="blockly-container"
                        v-model="blockData"
                        v-on:newWorkspace="workspace = $event"
                        v-bind:loadWorkflow="workflowId"
                    ></BlocklyComponent>
                    <div class="blockly-buttons">
                        <div class="run-status">
                            <p v-if="runInProgress">Running</p>
                            <p v-else>Run Workflow</p>
                        </div>
                        <md-button
                            @click="stopWorkflowRun()"
                            class="md-icon-button md-raised md-accent"
                            v-if="runInProgress"
                            id="stopButton"
                            >

                            <md-icon>stop</md-icon>
                            <md-tooltip md-direction="right"
                                >Stop Current Workflow Run</md-tooltip
                            >
                        </md-button>
                        <md-button
                            @click="validateWorkflows()"
                            class="md-icon-button md-raised md-accent"
                            v-else
                        >

                            <md-icon>play_arrow</md-icon>
                            <md-tooltip md-direction="right">Run Workflow</md-tooltip>
                        </md-button>
                    </div>
                </md-card>
            </div>

            <div class="workflow-divider" ref="divider">
                <div
                    id="resizeButton"
                    @mousedown="resizeWorkflowColumns"
                    v-on:dblclick="resetWorkflowColumns"
                    v-if="screenWidth > 800"
                ></div>
            </div>

            <div :class="['workflow-column', 'right-column']" ref="mapCol" id="mapCol">
                <md-card>

                    <md-tabs class="map-tabs" md-alignment="right">
                        <template slot="md-tab" slot-scope="{ tab }">
                        {{ tab.label }} <strong class="badge" v-if="tab.data.badge">({{ tab.data.badge }})</strong>
                        </template>
                        <md-tab
                        id="tab-map"
                        md-label="Map"
                        @click="/*ebxLogAnalytics(GA_EVENTS.TAB_MAP);*/"
                        >
                        <TheResultMap
                            :orgCustomisations="orgCustomisations || {}"
                            :isDashboardMap="false"
                            :blocks="blockData"
                            :show-loading-overlay="runInProgress"
                            ref="TheResultMap"
                        />
                        </md-tab>

                        <!-- <md-tab id="tab-code" md-label="Code" v-if="showCodePreview">
                        <md-content class="md-scrollbar">
                            <div v-if="disableCodePreview">
                            This area will allow you to preview and edit the generated
                            code.
                            </div>
                            <div v-else>
                            <pre
                                v-for="block in blockData"
                                :key="`runResult-${block.id}`"
                            >
    #name:{{ block.runResult.name }}
    #status:{{ block.runResult.status }}
    #mapId:{{ block.runResult.mapId }}
    #mapURL:{{ block.runResult.mapURL }}
    #code:{{ block.runResult.code || block.code }}
                                    </pre
                            >
                            </div>
                        </md-content>
                        </md-tab> -->
                        <md-tab
                        v-if="dashboardTabEnabled"
                        id="tab dash"
                        md-label="Dashboard"
                        @click="/*ebxLogAnalytics(GA_EVENTS.TAB_DASHBOARD);*/"
                        >
                        <Dashboard :blocks="blockData" ref="Dashboard" />
                        </md-tab>
                        <md-tab
                        v-if="!hideTasksTab"
                        id="tab downloads"
                        md-label="Tasks"
                        @click="/*ebxLogAnalytics(GA_EVENTS.TAB_DOWNLOADS);*/"
                        :md-template-data="{ badge: newRequests }"
                        >
                        <Tasks
                            :blocks="blockData"
                            ref="Downloads"
                            @new-requests="(noRequests) => newRequests = noRequests"
                            @new-docs="refreshAssets"
                            />
                        </md-tab>
                        <md-tab
                        v-if="!hideAssetsTab"
                        id="tab assets"
                        md-label="Assets"
                        @click="/*ebxLogAnalytics(GA_EVENTS.TAB_ASSETS);*/"
                        :md-template-data="{ badge: newRequests }"
                        >
                            <Assets ref="Assets" />
                        </md-tab>
                    </md-tabs>
                </md-card>
            </div>

        </div>

        <WorkflowLoad
            ref="workflowLoad"
            @load="onLoadWorkflow"
            @paste="onPastedWorkflow"
        />
        <FeaturedWorkflowsLoad
            ref="featuredWorkflowsLoad"
            @load-featured-block="loadFeaturedBlock"
        />

        <md-dialog-prompt
            :md-active.sync="savePrompt.isActive"
            v-model="savePrompt.model"
            @md-confirm="onSaveWorkflow(savePrompt.model)"
            md-title="Please provide workflow name"
            md-input-maxlength="30"
            md-input-placeholder="Workflow name"
            md-confirm-text="Save"
        />

        <md-snackbar
            :md-position="'center'"
            :md-duration="10000"
            :md-active.sync="snackbar.visible"
            md-persistent
        >
            <span>{{ snackbar.message }}</span>
        </md-snackbar>

        <md-dialog-alert
            :md-active.sync="errorDialog.visible"
            :md-content="errorDialog.message"
            md-confirm-text="OK" />

        <md-dialog :md-active.sync="showDatasetIdInfo">

            <md-dialog-content>
                <ol>
                    <li>Go to the <a href="https://developers.google.com/earth-engine/datasets/catalog" target="_blank">Earth Engine Data Catalog <md-icon>open_in_new</md-icon></a></li>
                    <br>
                    <li>Find the data you want to download, such as the <strong>Canada AAFC Annual Crop Inventory</strong>, and click to open its dedicated webpage.</li>
                    <br>
                    <li>
                        <p>To select the asset identifier, or ID, look for the <strong>Earth Engine Snippet</strong>, and copy the text between inverted commas, inside the parenthesis: ("this text here")</p>
                        <p>
                            <img src="@/assets/datasetID.gif" alt="Selecting the identifier text found between inverted commas, inside the parenthesis">
                        </p>
                    </li>
                </ol>
            </md-dialog-content>

            <md-dialog-actions>
                <md-button class="md-primary" @click="showDatasetIdInfo = false">Close</md-button>
            </md-dialog-actions>
        </md-dialog>

        <md-dialog :md-active.sync="showCommercialLicenseInfo">

            <md-dialog-content>
                <p>The dataset you've chosen could have restrictions on commercial use. Please refer to the license in the Earth Engine catalog before proceeding.</p>
            </md-dialog-content>

            <md-dialog-actions>
                <md-button class="md-primary" @click="showCommercialLicenseInfo = false">Close</md-button>
            </md-dialog-actions>
        </md-dialog>

        <md-dialog :md-active.sync="showIndicatorInfo">

            <md-dialog-content>
                <h3>{{indicatorContent.name}}</h3>
                <p>{{indicatorContent.description}}</p>
                <p><strong>Data sources:</strong></p>
                <ul>
                    <li v-for="url in indicatorContent.dataSourceUrls" :key="url"><a :href="url" target="_blank">{{url}}</a></li>
                </ul>
                <p>Last updated: {{indicatorContent.dateUpdated}}</p>
            </md-dialog-content>

            <md-dialog-actions>
                <md-button class="md-primary" @click="showIndicatorInfo = false">Close</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>
/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
*/
// INPUTS
import '../blocks/inputs/input_biomass'
import '../blocks/inputs/input_date_area_selection'
import '../blocks/inputs/input_area_selection'
import '../blocks/inputs/input_date_selection'
import '../blocks/inputs/input_optical_data'
import '../blocks/inputs/input_optical_data_only'
import '../blocks/inputs/input_radar_data'
import '../blocks/inputs/input_radar_data_only'
import '../blocks/inputs/input_dem_data'
import '../blocks/inputs/input_precipitation_data'
import '../blocks/inputs/input_precipitation_data_only'
import '../blocks/inputs/input_atmospheric_data'
import '../blocks/inputs/input_atmospheric_data_only'
import '../blocks/inputs/input_climate_data'
import '../blocks/inputs/input_climate_data_only'
import '../blocks/inputs/input_anthropogenic'
import '../blocks/inputs/input_night_lights'
import '../blocks/inputs/input_land_cover'
import '../blocks/inputs/input_ice_data'
import '../blocks/inputs/input_forest_data'
import '../blocks/inputs/input_hansen_forest_change'
import '../blocks/inputs/input_water_data'
import '../blocks/inputs/input_water_data_only'
import '../blocks/inputs/input_river_data'
import '../blocks/inputs/input_river_data_only'
import '../blocks/inputs/input_fire_data'
import '../blocks/inputs/input_fire_data_only'
import '../blocks/inputs/input_drought_data'
import '../blocks/inputs/input_scatter_y_band'
import '../blocks/inputs/input_data_selector'
// LEEDS INPUTS
import '../blocks/inputs/input_earthquake_data'
import '../blocks/inputs/input_glacier_data'
// ANALYSIS
import '../blocks/analysis/analyse_cloud_filter'
import '../blocks/analysis/analyse_principal_component_analysis'
import '../blocks/analysis/analyse_tasseled_cap_transformation'
import '../blocks/analysis/analyse_unsupervised_classification'
import '../blocks/analysis/analyse_supervised_classification'
import '../blocks/analysis/analyse_supervised_class_selector'
import '../blocks/analysis/analyse_fires_to_land_comparison'
import '../blocks/analysis/analyse_change_detection'
import '../blocks/analysis/analyse_timeseries'
import '../blocks/analysis/analyse_ndvi'
import '../blocks/analysis/analyse_ndwi'
import '../blocks/analysis/analyse_ndsi'
import '../blocks/analysis/analyse_nbi'
import '../blocks/analysis/analyse_spi'
import '../blocks/analysis/analyse_band_math'
import '../blocks/analysis/analyse_single_band_math'
import '../blocks/analysis/analyse_math_arithmetic_overriden'
import '../blocks/analysis/analyse_band_input'
import '../blocks/analysis/analyse_math_number_overriden'
import '../blocks/analysis/analyse_math_single_overriden'
import '../blocks/analysis/analyse_math_trig_overriden'
import '../blocks/analysis/analyse_math_constant_overriden'

// OUTPUTS
import '../blocks/outputs/output_optical_vis'
import '../blocks/outputs/output_dem_vis'
import '../blocks/outputs/output_radar_vis'
import '../blocks/outputs/output_other_vis'
import '../blocks/outputs/output_charts'
import '../blocks/outputs/output_table'
import '../blocks/outputs/output_band_histogram'
import '../blocks/outputs/output_optical_stats'
import '../blocks/outputs/output_download'
import '../blocks/outputs/output_band_selection'
// STRATA
import '../blocks/strata/strata_env_indicator'
import '../blocks/strata/strata_vuln_indicator'
import '../blocks/strata/strata_conflict_indicator'
import '../blocks/strata/strata_predictive_indicator'
import '../blocks/strata/strata_convergence'
import '../blocks/strata/strata_predictive_convergence'
import '../blocks/strata/strata_basket_sums_maplayer'
import '../blocks/strata/strata_convergence_maplayer'
import '../blocks/strata/strata_dashboard_viz'
import '../blocks/strata/strata_update_dashboard'
import '../blocks/strata/strata_predictive_dashboard'
import '../blocks/strata/strata_calculate_stress_score'
//GLOBE
import '../blocks/globe/globe_convergence'
import '../blocks/globe/globe_indicator'
import '../blocks/globe/globe_sat'
import '../blocks/globe/masks'
import '../blocks/globe/basket_calc'
import '../blocks/globe/basket_choice'
import '../blocks/globe/basket_aggr'
import '../blocks/globe/globe_interactive_map_viz'
import '../blocks/globe/globe_update_dashboard'
import '../blocks/globe/globe_nbi'

import BlocklyComponent from "../components/BlocklyComponent.vue";
import * as Blockly from "blockly/core";
import { organisationsCollection } from "@/firebase.js";
import { AuthService } from "@/services/auth.service";
import { AnalyticsService } from "@/services/analytics.service";
import { ImageService } from "@/services/image.service";
import firebase from "firebase/app";
import 'firebase/firestore';
import TheResultMap from "@/components/ResultMap/TheResultMap.vue";
import Dashboard from "@/components/Dashboard.vue";
import Tasks from "@/components/Tasks.vue";
import Assets from "@/components/Assets.vue";
import WorkflowLoad from "@/components/WorkflowLoad.vue";
import TermsDialog from "@/components/TermsDialog.vue";
import NetPromoterSurvey from "@/components/NetPromoterSurvey.vue";
import AnalyticsDialog from "@/components/AnalyticsDialog.vue";
import FeaturedWorkflowsLoad from "@/components/FeaturedWorkflowsLoad";
import { GA_EVENTS, GA_SYSTEM_EVENTS, GA_EVENT_PROPS } from "@/constants/gaConstants.js";
import { AreaService } from "@/services/area.service.js";
import { ManageDialogsService } from '@/services/manageDialogs.service';
import { ConfigService } from '@/services/config.service';
import * as configConstants from "@/config/constants";
import { OrgConfig } from "@/config/main";
import {v4 as uuidv4} from 'uuid';

export default {
    name: "Workflow",
    props: {
        workflowId: {
            type: String,
            required: false,
        },
    },
    data: () => ({
        user: null,
        blockData: [],
        runInProgress: false,
        savePrompt: {
            isActive: false,
            model: "",
        },
        downloadPrompt: {
            isActive: false,
            model: "",
        },
        // isCodeVisible: true, // default to true to maintain order of tabs
        errorDialog: {
            visible: false,
            message: "",
        },
        snackbar: {
            visible: false,
            message: "",
        },
        workspace: null,
        screenWidth: window.innerWidth,
        flexDirection: "row",
        tncsStatus: '',
        showTermsDialog: false,
        tncsVersion: '',
        tncsDoc: '' ,
        disableTncsAccept: true,
        showAnalytics: false,
        responsesCollections: {},
        userResponseData: {},
        disableRun: false,
        orgConfig: null,
        orgType: null,
        newRequests: 0,
        showDatasetIdInfo: false,
        showCommercialLicenseInfo: false,
        showIndicatorInfo: false,
        indicatorContent: {},
    }),
    components: {
        BlocklyComponent,
        TheResultMap,
        Dashboard,
        Tasks,
        Assets,
        WorkflowLoad,
        TermsDialog,
        NetPromoterSurvey,
        AnalyticsDialog,
        FeaturedWorkflowsLoad
    },
    watch: {
        blockData: {
            deep: true,
            handler: "updateRunInProgress",
        },
        screenWidth(newWidth) {
            if(newWidth <= 800) {
                let leftColumn = this.$refs.blockCol;
                let rightColumn = this.$refs.mapCol;
                this.flexDirection = "column"

                leftColumn.style.width = "100%";
                rightColumn.style.width = "100%";
                Blockly.svgResize(this.workspace);
            } else {
                this.flexDirection = "row"
            }
        },
    },
    created() {
        if(this.screenWidth < 800) {
            this.flexDirection = "column";
        }
        window.addEventListener('resize', this.onResize)

        window.onbeforeunload = () => {
            let dirty = this.blockData.length > 0;
            return dirty ? "" : null;
        }

        let self = this;
        this.subscription = AuthService.loggedUser$.subscribe((user) => {
            console.log("workflow.vue logged user subscriber event") ;
            self.user = user;
            // Show the dialog if analyticsAgreed is unset or set to null
            self.showAnalytics = (typeof self.user.analyticsAgreed === 'undefined' || self.user.analyticsAgreed===null);

            // default guest user and bootstap superadmin does not have an orgRef
            if (!this.orgRef) {
                this.errorDialog.message = "You'll need to assign yourself to an organisation before you can use the workspace!";
                this.errorDialog.visible = true;
                return;
            }

            this.orgRef.onSnapshot((orgDoc) => {
                if (orgDoc.exists) {

                    // check if terms and conditions are switched on for the org
                    let showOrgTerms = orgDoc.data().enableTermsAndConditions;

                    if (showOrgTerms) {
                        // get terms version and current link to tnc html doc
                        const location = self.user.orgId + "/termsandconditions/current";
                        organisationsCollection.doc(location).get().then(current => {
                            if (current.exists) {
                                self.tncsVersion = current.data().ref.id;
                                current.data().ref.get().then((versiondoc)=> {
                                      if(versiondoc.exists)
                                      {
                                        self.tncsDoc = versiondoc.data().reference ;
                                      }
                                      else
                                      {
                                         self.tncsDoc = "";
                                         self.disableTncsAccept = true ;
                                      }
                                   })
                                   // show T&C pop up if user hasn't agreed, or new version
                                   if (user.termsAgreed !== undefined ) {
                                        self.showTermsDialog = !user.termsAgreed;
                                        user.termsAgreed ? self.tncsStatus = 'agree' : self.tncsStatus = 'disagree';
                                    }
                                    if (self.user.termsVersion !== self.tncsVersion) {
                                        self.showTermsDialog = true;
                                    }

                            }// if current.exists
                        });
                    }
                }
            });

            ConfigService.getOrgConfig(this.user.orgId).then(function(config){
                this.orgConfig = config;
                this.orgType = this.orgConfig.accessType;
            }.bind(this));

        });


        // get the userResponses collection from firebase organisation
        this.responsesCollections = organisationsCollection.doc(this.user.orgId).collection('stats').doc('netPromoterQuestion').collection('userResponses');

        // default object to store for new user with no NPS history
        this.userResponseData = {
            loginCounter: 1,
            responseCounter: 0,
            npsStatus: ''
        };

        // update/write to firebase for every login
        this.writeUserStats(this.user.uid, this.userResponseData)

        this.datasetIdDialogSubscription = ManageDialogsService.infoDatasetId$.subscribe( () => {
            this.showDatasetIdInfo = true;
        });

        this.commercialLicenseDialogSubscription = ManageDialogsService.commercialLicenseCaveat$.subscribe( () => {
            this.showCommercialLicenseInfo = true;
        });

        this.indicatorInfoSubscription = ManageDialogsService.indicatorInfo$.subscribe( (content) => {
            this.showIndicatorInfo = true;
            this.indicatorContent = content;
        });

    },
    beforeDestroy() {
        this.subscription.unsubscribe();
        this.datasetIdDialogSubscription.unsubscribe();
        this.commercialLicenseDialogSubscription.unsubscribe();
        console.log("workflow.vuw unsubcribe") ;
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        cancelAnalytics(flag) {
            this.showAnalytics = flag;
        },
        writeUserStats: function(id, data) {
            this.responsesCollections.doc(id).get().then((doc) => {
                // if user collection doesn't exit, create it else update it
                if (!doc.exists) {
                    doc.ref.set(data);
                } else {
                    data = doc.data();
                    doc.ref.update({
                        loginCounter: firebase.firestore.FieldValue.increment(1)
                    });

                    data.loginCounter++;

                    if (data.npsStatus === '') {
                        if (data.loginCounter === this.initialNPS) {
                            this.showDialog = true;
                            doc.ref.update({
                                npsStatus: 'showing'
                            });
                            data.npsStatus = 'showing'
                        }
                    } else if (data.npsStatus === 'responded') {
                        if (data.loginCounter === this.ongoingNPS) {
                            this.showDialog = true;
                            doc.ref.update({
                                npsStatus: 'showing'
                            });
                            data.npsStatus = 'showing'
                        }
                    } else if (data.npsStatus === 'showing') {
                        this.showDialog = true;
                    }
                }
            });
        },
        validateWorkflows() {
            let validWorkflow = true;
            this.blockData.forEach((blockData) => {
                let block = this.workspace.getBlockById(blockData.id);
                if (block.warning) {
                    this.errorDialog.message = 'You\'re running a workflow that contains a block with an active warning. Please check your work and try again.';
                    this.errorDialog.visible = true;
                    validWorkflow = false;
                }
            });

            if (validWorkflow) {
                this.runWorkflow();
            }
        },
        runWorkflow() {
            AuthService.checkUserAuth();

            this.errorDialog.visible = false;
            this.$refs.Dashboard?.clearCells();
            this.$refs.TheResultMap.clearMap();
            let self = this;

            // getAreasAndShapesForRunDoc has an optional areaIds parameters,
            // which we could use to filter only for areas relevant to this run
            let areas = JSON.stringify(AreaService.getAreasAndShapesForRunDoc());

            /**
             * image in object form:
             * images: {
             *     ID: {
             *          image data
             *     }
             * }
             */

            let imagesObject = ImageService.getImagesInObjectForm();
            let images = ImageService.getImages();

            // ensures blocks that rely on other blocks to finish are
            // set to run first
            // TODO: consider if scalable, proper orchestration of run jobs may be required
            // if one workflow relies on another then they must be run once the first job is
            // successful or fails
            let blockDataInOrder = []
            let imageWorkflows = []
            let nonImageWorkflows = []

            // for each block generate a unique runID which will be used to correlate
            // to the subworkflows at run time
            this.blockData.forEach((blockData) => {

                // check if top block has same id as a root block in the image service
                let index = images.findIndex((image) => image.rootBlockID === blockData.id)
                blockData.runID = uuidv4().replaceAll('-', '');

                if(index !== -1) {
                    // save the run doc ID for the images subworkflow, so
                    // they can be used on the backend to correlate images
                    let imageID = images[index].ID;
                    imagesObject[imageID].runID = blockData.runID;
                    imageWorkflows.push(blockData);
                } else {
                    nonImageWorkflows.push(blockData);
                }
            })

            blockDataInOrder = imageWorkflows.concat(nonImageWorkflows);
            // should be okay to do this;
            this.blockData = blockDataInOrder;

            this.blockData.forEach((blockData) => {
                let block = this.workspace.getBlockById(blockData.id)

                if(!block.disabled){ // checks if block isn't disabled TODO WE NEED TO DO MORE STRINGENT CLIENT TESTING WITH BLOCKS BEFORE THIS

                    let blockXMLText = '<xml>' + Blockly.Xml.domToText(Blockly.Xml.blockToDom(block)) + '</xml>';

                    blockData.isLoading = true;
                    this.orgRef
                        .collection("runs")
                        .doc(blockData.runID)
                        .set({
                            status: "started",
                            startedAt: firebase.firestore.FieldValue.serverTimestamp(),
                            submittedBy: {
                              uid: self.user.uid,
                              email: self.user.email,
                              displayName: self.user.displayName,
                              orgId: self.user.orgId
                            },
                            hasTasks: false,
                            xml: blockXMLText,
                            areas: areas,
                            images: imagesObject
                        })
                        .then(
                            () => {
                                let documentReference = this.orgRef.collection("runs").doc(blockData.runID)
                                AnalyticsService.logAnalyticsEvent(GA_EVENTS.WORKFLOW_RUN);
                                blockData.unsubscribe = documentReference.onSnapshot(async function (doc) {
                                    let result = doc.data();
                                    result.name = self.getUniqueName(result.layerName, blockData);
                                    if (result.status === "completed") {
                                        // add the outputs to the runResult
                                        let collRef = await doc.ref.collection('outputs').get();
                                        console.info(`Found ${collRef.size} outputs.`);
                                        if(!collRef.empty){
                                            let outputs = [];
                                            collRef.forEach((outputDoc) => {
                                                let data = outputDoc.data();
                                                outputs.push(JSON.parse(data.output));
                                            });
                                            if(outputs.length > 0){
                                                result.outputs = outputs.sort((a, b) => b.displayOrder - a.displayOrder);
                                            }
                                        }
                                        if (result.prompt !== '') {
                                            self.errorDialog.message = prompt;
                                            self.errorDialog.visible = true;
                                        }
                                        blockData.runResult = result;
                                        blockData.isLoading = false;
                                        blockData.unsubscribe();
                                        // TODO doc.delete()
                                        try {
                                            var now = firebase.firestore.Timestamp.now()
                                            var time = now - blockData.runResult.startedAt;
                                            time = time.toFixed(2);
                                            console.log("Block took "+time+"s");
                                            AnalyticsService.logAnalyticsEvent(GA_EVENTS.WORKFLOW_BLOCK_COMPLETE, time, {'layer_name': result.layerName});
                                        } catch (err) {
                                            console.error("Problem calculating block run time for analytics: "+err);
                                        }
                                    } else if (result.status === "error") {
                                        blockData.unsubscribe();
                                        blockData.runResult = result;
                                        let errmsg=blockData.runResult.errmsg

                                        if (errmsg=='spi'){errmsg='SPI Index period must be shorter than 1 year.'}

                                        if (errmsg=='area'){errmsg='No area selected.'}

                                        if (errmsg=='noData'){self.errorDialog.message = 'No data available for your selection. Try changing dataset and/or date range.'}

                                        if (errmsg.slice(0,21)=="Image.select: Pattern"){errmsg='It looks like the area/date/band combination you selected doesnt contain any data. Please revise and retry.'}

                                        // error messages for when blocks are loose.
                                        if (errmsg=='NDVI not connected')
                                        {self.errorDialog.message = 'Your NDVI block is not attached to an Input block.'}
                                        else if (errmsg=='NDWI not connected')
                                        {self.errorDialog.message = 'Your NDWI block is not attached to an Input block.'}
                                        else if (errmsg=='NDSI not connected')
                                        {self.errorDialog.message = 'Your NDSI block is not attached to an Input block.'}
                                        else if (errmsg=='NBI not connected')
                                        {self.errorDialog.message = 'Your NBI block is not attached to an Input block.'}
                                        else if (errmsg=='SPI not connected')
                                        {self.errorDialog.message = 'Your SPI block is not attached to an Input block.'}
                                        else if (errmsg=='comparison not connected')
                                        {self.errorDialog.message = 'Your Comparison block is not attached to an Input block.'}
                                        else if (errmsg=='loose time series')
                                        {self.errorDialog.message = 'Your Time Series block is not attached to an Input block.'}
                                        else if (errmsg=='no vis block')
                                        {self.errorDialog.message = 'Map Visualisation Output block is required.'}
                                        else if (errmsg=='loose vis')
                                        {self.errorDialog.message = 'Visualisation block is not attached to an Input or Analysis block.'}
                                        else if (errmsg=='noOpticalData')
                                        {self.errorDialog.message = 'No imagery is available. Try changing Data type.'}
                                        else if (errmsg=='cloudFilter')
                                        {self.errorDialog.message = 'No imagery is available. Try increasing Max Cloud Cover.'}

                                        else {self.errorDialog.message = `Error while running workflow. Error: ${errmsg}`}
                                        self.errorDialog.visible = true;
                                        blockData.isLoading = false;
                                        let event_props = {};
                                        event_props[GA_EVENT_PROPS.ERR_INFO] = errmsg;
                                        AnalyticsService.logAnalyticsEvent(GA_SYSTEM_EVENTS.ERROR, null, event_props);
                                    }
                                }.bind(this));
                            },
                            (error) => {

                                if(error.code=="permission-denied")
                                {
                                    if(this.showTermsDialog) // user in preview mode
                                    {
                                    self.errorDialog.message = `Preview Restricted: Please refresh browser and then accept Terms and Conditions to run a workflow`;
                                    }
                                    else
                                    {
                                    self.errorDialog.message = `Restricted: Terms & Conditions may have changed: Please refresh browser and then accept terms and conditions`;
                                    }
                                }

                                else
                                {
                                self.errorDialog.message = `Error while running workflow. Error: ${error.code}`;

                                }

                                self.errorDialog.visible = true;
                                self.isLoading = false;

                                AnalyticsService.logAnalyticsEvent(GA_SYSTEM_EVENTS.ERROR, error.code);

                            }
                        )}
                });

            console.log("run workflow") ;
        },
        stopWorkflowRun() {
            if (this.blockData) {
                this.blockData.forEach((block) => {
                block.unsubscribe && block.unsubscribe();
                block.isLoading = false;
                });
                this.updateRunInProgress(this.blockData); // For some reason watch is not triggering after blocks are updated, so we call update manually
            }
            // console.debug("Logging a workflow_stop event, user "+ this.user.uid + ", org " + this.user.orgId);
            AnalyticsService.logAnalyticsEvent(GA_EVENTS.WORKFLOW_STOP);
        },
        updateRunInProgress(blockData) {
            this.runInProgress =
                blockData &&
                blockData.length > 0 &&
                blockData.some((block) => block.isLoading);
        },
        loadWorkflow() {
            AnalyticsService.logAnalyticsEvent(GA_EVENTS.DIALOG_LOAD_WORKFLOW);
            this.$refs.workflowLoad.showDialog();
        },
        loadFeaturedWorkflows() {
            this.$refs.featuredWorkflowsLoad.showDialog()
        },
        onLoadWorkflow(workflowName) {
            if (!workflowName || !workflowName.trim()) {
                this.errorDialog.message = "Could not load workflow with blank name";
                this.errorDialog.visible = true;
                return;
            }
            let props = {};
            props[GA_EVENT_PROPS.NAME] = workflowName;
            AnalyticsService.logAnalyticsEvent(GA_EVENTS.WORKFLOW_LOAD, null, props);

            let self = this;
            let workspace = Blockly.getMainWorkspace();
            this.orgRef
                .collection("workflows")
                .doc(workflowName)
                .get()
                .then(
                (doc) => {
                    if (!doc.exists) {
                    self.errorDialog.message = `Workflow '${workflowName}' does not exist!`;
                    self.errorDialog.visible = true;
                    return;
                    }

                    self.xml = doc.data().blockDefinition;
                    let blockDefinition = Blockly.Xml.textToDom(self.xml);
                    Blockly.Xml.clearWorkspaceAndLoadFromXml(
                    blockDefinition,
                    workspace
                    );
                },
                (error) => {
                    self.errorDialog.message = `Error while loading workflow '${workflowName}'. Error: ${error}`;
                    self.errorDialog.visible = true;
                    AnalyticsService.logAnalyticsEvent(GA_SYSTEM_EVENTS.ERROR, error.code);
                }
                );
        },
        onRunWorkflow(workflowName) {
          if (!workflowName || !workflowName.trim()) {
                this.errorDialog.message = "Could not run workflow with blank name";
                this.errorDialog.visible = true;
                return;
            }
            let props = {};
            props[GA_EVENT_PROPS.NAME] = workflowName;
            AnalyticsService.logAnalyticsEvent(GA_EVENTS.WORKFLOW_RUN, null, props);

            this.orgRef
                .collection("workflows")
                .doc(workflowName)
                .get()
                .then(doc => {
                    if (!doc.exists) {
                        self.errorDialog.message = `Workflow '${workflowName}' does not exist!`;
                        self.errorDialog.visible = true;
                        return;
                    }
                    self.xml = doc.data().blockDefinition;
                });
        },
        onPastedWorkflow(xml) {
            // TODO validate xml
            let workspace = Blockly.getMainWorkspace();
            let blockDefinition = Blockly.Xml.textToDom(xml);
            Blockly.Xml.clearWorkspaceAndLoadFromXml(
                blockDefinition,
                workspace
            )
        },
        saveWorkflow() {
            AnalyticsService.logAnalyticsEvent(GA_EVENTS.DIALOG_SAVE_WORKFLOW);
            this.savePrompt.model = "";
            this.savePrompt.isActive = true;
        },
        onSaveWorkflow(workflowName) {
            if (!workflowName || !workflowName.trim()) {
                this.errorDialog.message = "Could not save workflow with blank name";
                this.errorDialog.visible = true;
                return;
            }

            let props = {};
            props[GA_EVENT_PROPS.NAME] = workflowName;
            AnalyticsService.logAnalyticsEvent(GA_EVENTS.WORKFLOW_SAVE, null, props);

            let workspaceDom = Blockly.Xml.workspaceToDom(Blockly.getMainWorkspace());
            let xml = Blockly.Xml.domToText(workspaceDom);
            let self = this;

            this.orgRef
                .collection("workflows")
                .doc(workflowName)
                .set({
                blockDefinition: xml,
                })
                .then(
                () => {
                    self.snackbar.message = `Successfully saved workflow '${workflowName}'`;
                    self.snackbar.visible = true;
                },
                (error) => {
                    self.errorDialog.message = `Error while saving workflow '${workflowName}'. Error: ${error}`;
                    self.errorDialog.visible = true;
                    AnalyticsService.logAnalyticsEvent(GA_SYSTEM_EVENTS.ERROR, error.code);
                }
                );
        },
        shareWorkflow(){
            // uses Async API
            var copyToClipboard = text => {
                if(!navigator.clipboard){
                    legacyCopyToClipboard(text);
                    return;
                }
                navigator.clipboard.writeText(text).then(() => {
                    // TODO tell user they have copied text
                }, (error) => {
                    console.error("Could not copy text: ", error)
                    // TODO tell user they have failed to copy text
                    AnalyticsService.logAnalyticsEvent(GA_SYSTEM_EVENTS.ERROR, error.code);
                });
            }

            // if async api fails use none async legacy code
            var legacyCopyToClipboard = text => {
                let textArea = document.createElement("textarea");
                textArea.value = text;

                textArea.style.top = "0";
                textArea.style.left = "0";
                textArea.style.position = "fixed";

                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

                try {
                document.execCommand('copy');
                // TODO tell user they have copied text
                } catch (err) {
                console.error('Fallback: Oops, unable to copy', err);
                // TODO tell user they have failed to copy text
                }

                document.body.removeChild(textArea);
            }

            let workspaceDom = Blockly.Xml.workspaceToDom(Blockly.getMainWorkspace());
            let xml = Blockly.Xml.domToText(workspaceDom);

            copyToClipboard(xml);
        },
        getrefforcap() {
            return this.$refs.mapCol;
        },
        downloadData() {  //for the half finished PNG capture capabilities
            //will need npm install of html2canvas
            let myself = this;
            this.$refs.TheResultMap.getCanvas().then(function (canvas) {
                var img = canvas
                .toDataURL("image/png")
                .replace("image/png", "image/octet-stream");
                myself.downloadFile(img);
            });
            return;
        },
        downloadFile(data) {
            // Create invisible a element
            const a = document.createElement("a");
            a.style.display = "none";
            document.body.appendChild(a);
            a.href = data;
            a.click(function(e) {e.preventDefault()});
            // Cleanup
            window.URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
        },
        getUniqueName(layerName, block) {
            if (layerName) {
                if (this.blockData) {
                let blocksWithSameName = this.blockData.filter(
                    (bd) => bd === block || bd.runResult.layerName === layerName
                );
                let index = blocksWithSameName.indexOf(block);
                if (index > 0) {
                    return `${layerName} (${index})`;
                } else {
                    return layerName;
                }
                } else {
                return layerName;
                }
            }
        },
        resizeWorkflowColumns(event) {
            event.preventDefault();

            document.onmousemove = event => {
                event.preventDefault();
                let leftColumn;
                let rightColumn;
                leftColumn = this.$refs.blockCol;
                rightColumn = this.$refs.mapCol;

                let divider = this.$refs.divider;
                let totalWidth = window.getComputedStyle(this.$refs.workflowRow).width;
                totalWidth = parseInt(totalWidth.replace('px', ''));
                let leftColumnWidth = (event.pageX - (divider.style.width / 2));
                let rightColumnWidth = (totalWidth - leftColumnWidth - (divider.style.width / 2));
                leftColumn.style.width = leftColumnWidth/totalWidth*100 + '%';
                rightColumn.style.width = rightColumnWidth/totalWidth*100 + '%';
                Blockly.svgResize(this.workspace);
            }
            document.onmouseup = () => {
                document.onmouseup = null;
                document.onmousemove = null;
            }
        },
        resetWorkflowColumns(){
            let leftColumn = this.$refs.mapCol;
            let rightColumn = this.$refs.blockCol;

            leftColumn.style.width = '50%';
            rightColumn.style.width = '50%';
            Blockly.svgResize(this.workspace);
        },
        onResize() {
            this.screenWidth = window.innerWidth;
        },
        clearWorkflow(){
            AnalyticsService.logAnalyticsEvent(GA_EVENTS.WORKFLOW_CLEAR);
            this.workspace.clear();
            this.blockData = [];
        },
        updateDisableRun(value) {
            this.disableRun = value;
        },
        loadFeaturedBlock(id) {
            this.$refs.blocklyComponent.loadWorkflowFromUrl(id)
        },
        refreshAssets() {
            this.$refs.Assets.refreshAssets();
        }
    }, //methods
    computed: {
        orgRef() {
            return this.user.orgId ? organisationsCollection.doc(this.user.orgId) : null;
        },
        showCodePreview() {
            return OrgConfig.isFeatureShown(this.orgConfig, configConstants.FEATURES.CODE_PREVIEW);
        },
        disableCodePreview() {
            return OrgConfig.isFeatureDisabled(this.orgConfig, configConstants.FEATURES.CODE_PREVIEW);
        },
        hideAssetsTab() {
            return !OrgConfig.isFeatureShown(this.orgConfig, configConstants.FEATURES.DOWNLOADS) && !OrgConfig.isFeatureShown(this.orgConfig, configConstants.FEATURES.POLYGON_UPLOAD);
        },
        hideTasksTab() {
            return !OrgConfig.isFeatureShown(this.orgConfig, configConstants.FEATURES.DOWNLOADS) && !OrgConfig.isFeatureShown(this.orgConfig, configConstants.FEATURES.POLYGON_UPLOAD);
        },
        dashboardTabEnabled() {
            return OrgConfig.isFeatureShown(this.orgConfig, configConstants.FEATURES.TAB_DASHBOARD);
        },
        workflowsLibraryEnabled() {
            return OrgConfig.isFeatureShown(this.orgConfig, configConstants.FEATURES.WORKFLOWS_LIBRARY);
        },
        saveWorkflowsEnabled() {
            return OrgConfig.isFeatureShown(this.orgConfig, configConstants.FEATURES.WORKFLOWS_SAVE);
        },
        loadWorkflowsEnabled() {
            return OrgConfig.isFeatureShown(this.orgConfig, configConstants.FEATURES.WORKFLOWS_LOAD);
        },
        orgCustomisations() {
            return this.orgConfig ? this.orgConfig.getConfig(configConstants.CONFIG_TYPE.CUSTOMISATION) : undefined;
        },
    },
};
</script>